/**
 * TEMPORARY DEMO LOGOUT PAGE
 * 
 * This page simulates a logout screen for demonstration purposes only.
 * It allows testing of localStorage persistence by emulating a user session.
 * 
 * ⚠️ THIS IS NOT FOR PRODUCTION USE
 * This will be removed when proper authentication is implemented.
 */

import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { LogIn, CheckCircle } from 'lucide-react';
import { useDemoSession } from '@/providers/DemoSessionProvider';

export function DemoLogoutPage() {
  const { userName, login } = useDemoSession();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-background to-muted/20 p-4">
      <Card className="w-full max-w-md p-8 space-y-6 text-center shadow-lg">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-[var(--accent-bg-outline)] p-4">
            <CheckCircle className="h-12 w-12 text-[var(--accent-text-on-outline)]" />
          </div>
        </div>

        {/* Success Message */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            Successfully Logged Out
          </h1>
          <p className="text-muted-foreground">
            <span className="font-medium text-foreground">{userName}</span> has been logged out of Access Projects.
          </p>
        </div>

        {/* Info Box */}
        <div className="rounded-lg border border-border bg-muted/50 p-4 text-sm text-muted-foreground">
          <p className="mb-2">
            This simulates closing your browser or ending your session.
          </p>
          <p>
            Your preferences are saved and will be restored when you log back in.
          </p>
        </div>

        {/* Login Button */}
        <Button
          onClick={login}
          size="lg"
          className="w-full gap-2"
        >
          <LogIn className="h-4 w-4" />
          Log In
        </Button>

        {/* Demo Notice */}
        <div className="pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            ⚠️ This is a demo feature for testing purposes only
          </p>
        </div>
      </Card>
    </div>
  );
}
